import { Action, actionCreator } from 'util/actions';
import { createReducer } from 'util/reducers';

// Action types

const SET_OVERLAY = Symbol('ui/SET_OVERLAY');
const REMOVE_OVERLAY = Symbol('ui/REMOVE_OVERLAY');

export enum OverlayType {
  CreateBoard = 'create_board',
  ClosedBoards = 'closed_boards',
}

type SetOverlayAction = Action<typeof SET_OVERLAY, OverlayType>;
type RemoveOverlayAction = Action<typeof REMOVE_OVERLAY, null>;

export type OverlayState = null | string;

// Reducer
const initialState: OverlayState = null;

export default createReducer(initialState, {
  [SET_OVERLAY](state: OverlayState, { payload }: SetOverlayAction) {
    return payload;
  },

  [REMOVE_OVERLAY]() {
    return null;
  },
});

// Action creators
export const setOverlay = actionCreator<SetOverlayAction>(SET_OVERLAY);
export const removeOverlay = actionCreator<RemoveOverlayAction>(REMOVE_OVERLAY);



// WEBPACK FOOTER //
// ./app/gamma/src/modules/state/ui/overlay.ts